import React, { useEffect } from 'react';
import '../../styles/Magunkrol.css';
import { Link } from 'react-router-dom';

class Kereszt extends React.Component {
    render() {
        return (
            <img src={process.env.PUBLIC_URL + '/assets/kereszt.png'} alt="kereszt" className='kereszt-icon' />
        );
    }
}

function Magunkrol() {

    // Preload the kereszt image to prevent flickering
    useEffect(() => {
        const img = new Image();
        img.src = process.env.PUBLIC_URL + '/assets/kereszt.png';
    }, []);

    const listItems = [
        "Egyesületünk, az Egy hajóban... projektet is kezelő Salina Alapítvány",
        "Hőseink",
        "kapcsolat, elérhetőségeink",
        "Partnereink, Támogatóink"
    ];



    return (
        <>
            <div className='magunkrol-container'>
                {listItems.map((item, index) => (
                    <div className='magunkrol-text-container' key={index}>
                        <Kereszt />
                        <Link to={
                            index === 0 ? '/salina' :
                            index === 1 ? '' :
                            index === 2 ? '/kapcsolat' :
                            index === 3 ? '/partnereink-tamogatoink' : ''
                        } className='magunkrol-list-item'>{item}</Link>
                    </div>
                ))}
            </div>
        </>
    );
}

export default Magunkrol;
